export default "__VITE_ASSET__mkHo3i8v__"